import { Pipe, PipeTransform } from '@angular/core';
import { FreeBusyStateEnum } from 'src/app/components/contact-status/appointments/free-busy-state-enum';

@Pipe({
   name: 'toFreeBusyStateClass',
})
export class ToFreeBusyStateClass implements PipeTransform {
   transform(enumValue: number): string {
      try {
         return FreeBusyStateEnum.valueOf(enumValue).cssClass;
      } catch (e) {
         return FreeBusyStateEnum.NO_DATA.cssClass;
      }
   }
}
